export function getListOf(models, prop) {
    return models.reduce((uniqueValue, item) => {
        if (uniqueValue.indexOf(item[prop]) === -1) {
            uniqueValue.push(item[prop]);
        }
        return uniqueValue;
    },[]);
    };